import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ShowProductosGuardService  {

    constructor(public router: Router) {}

    canActivate(): boolean | UrlTree {

        if (!environment.features.hasProductos) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
